import { render, staticRenderFns } from "./AgreeSign.vue?vue&type=template&id=1572c6a4&scoped=true&"
import script from "./AgreeSign.vue?vue&type=script&lang=js&"
export * from "./AgreeSign.vue?vue&type=script&lang=js&"
import style0 from "./AgreeSign.vue?vue&type=style&index=0&id=1572c6a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1572c6a4",
  null
  
)

export default component.exports